namespace SolovisGateway.Admin.Authentication {

    /**
     * ExternalAuthAppsListControl presents the user interface for administrating External Auth Apps.
     */
    export class ExternalAuthAppsListControl extends Solovis.UI.BaseControl {

        private _externalAuthApps: Array<ExternalAuthAppModel>;
        private _allOrganizations: Array<ExternalAuthAppOrganizationModel>;
        private _initError;

        private _dataGrid: DevExpress.ui.dxDataGrid;
        private _gridHelper: Solovis.DevExtreme.DxDataGridHelper;

        constructor(options) {
            super(options);
            this._externalAuthApps = new Array<ExternalAuthAppModel>();
            this._allOrganizations = new Array<ExternalAuthAppOrganizationModel>();
        }

        public async doInitAsync() {
            let self = this;

            return await Solovis.Rpc.invoke(
                "~/Rpc/AuthIntegration/GetAllExternalAuthApps",
                {},
                function (response, success) {
                    if (success
                        && response
                        && response.result
                        && response.result.externalAuthApps) {

                        response.result.externalAuthApps.forEach(externalAuthApp => {
                            let model = new ExternalAuthAppModel(externalAuthApp);
                            self._externalAuthApps.push(model);
                        });
                    }
                    else {
                        console.log("ERROR: ExternalAuthAppsListControl.doInitAsync");
                        console.log(response.error);
                        self._initError = response.error;
                    }
                });
        }

        public doRender() {
            let self: ExternalAuthAppsListControl = this;

            let dataGridContainer = $("<div>").appendTo(this.container);

            let store = new DevExpress.data.ArrayStore({
                key: 'code',
                data: self._externalAuthApps
            });

            dataGridContainer.dxDataGrid({
                dataSource: {
                    store: store,
                    sort: 'name'
                },

                allowColumnResizing: true,
                allowColumnReordering: true,
                rowAlternationEnabled: true,
                searchPanel: { visible: true },
                columnChooser: { enabled: false },
                editing: {
                    mode: "form",
                    allowDeleting: true,
                    allowAdding: true
                },

                onRowRemoving: self._onRowRemovingHandler,
                onRowInserting: self._onRowInsertingHandler,
                onInitNewRow: self._onInitNewRowHandler,
                onEditorPreparing: self._onEditorPreparingHandler,

                columns: [
                    {
                        dataField: 'name',
                        dataType: 'string',
                        caption: 'Name',
                        validationRules: [{ type: "required" }],
                        allowSorting: true,
                        width: 200,
                        cellTemplate: (container, options) => {
                            let data = <ExternalAuthAppModel>options.data;
                            $('<a/>')
                                .text(data.name)
                                .attr("href", Solovis.resolveUrl(`~/Admin/Authentication/ExternalAuthApps/Details/${data.code}`))
                                .appendTo(container);
                        }
                    },
                    {
                        dataField: 'code',
                        dataType: 'string',
                        caption: 'Code',
                        validationRules: [{ type: "required" }],
                        allowSorting: true,
                        width: 200
                    },
                    {
                        dataField: 'sharedSigningKey',
                        dataType: 'string',
                        caption: 'Shared Signing Key',
                        validationRules: [{ type: "required" }],
                        visible: false
                    },
                    {
                        dataField: 'globalAuthAllowed',
                        dataType: 'boolean',
                        caption: 'Is Global Auth Allowed',
                        visible: true,
                        allowSorting: true,
                        width: 160
                    },
                    {
                        dataField: 'loginUrl',
                        dataType: 'string',
                        caption: 'Login URL',                        
                        visible: true
                    },
                    {
                        dataField: 'logoutUrl',
                        dataType: 'string',
                        caption: 'Logout URL',
                        visible: true
                    },
                ],
            });

            this._dataGrid = dataGridContainer.dxDataGrid("instance");
            this._gridHelper = new Solovis.DevExtreme.DxDataGridHelper(this._dataGrid);
        }

        private _onRowRemovingHandler(e: any) {
            let deferred = $.Deferred();
            if (e.data) {
                let data = <ExternalAuthAppModel>e.data;
                Solovis.Rpc.invoke(
                    "~/Rpc/AuthIntegration/DeleteExternalAuthApp",
                    data.toDeleteParams(),
                    function (response, success) {
                        if (success) {
                            deferred.resolve();
                        }
                        else {
                            console.log('ERROR: ExternalAuthAppsListControl._onRowRemovingHandler');
                            console.log(response.error);
                            deferred.reject(response.error.message);
                        }
                    });
            }

            e.cancel = deferred;
        }

        private _onRowInsertingHandler(e: any) {
            let deferred = $.Deferred();

            if (e.data) {
                let data = new ExternalAuthAppModel(e.data);
                Solovis.Rpc.invoke(
                    "~/Rpc/AuthIntegration/AddExternalAuthApp",
                    data.toAddParams(),
                    function (response, success) {
                        if (success) {
                            data.clearSensitiveData();
                            e.data = data;
                            deferred.resolve();
                        }
                        else {
                            console.log('ERROR: ExternalAuthAppsListControl._onRowInsertingHandler');
                            console.log(response.error);
                            deferred.reject(response.error.message);
                        }
                    });
            }

            e.cancel = deferred;
        }

        private _onInitNewRowHandler(e: any) {
            ExternalAuthAppModel.initializeData(e.data);
        }

        private _onEditorPreparingHandler(e: any) {
            if (e.parentType == "dataRow" && e.dataField == "sharedSigningKey") {
                e.editorOptions.mode = 'password';
            }
        }
    }
}